import * as React from 'react'
import {hot} from 'react-hot-loader'
import AppController from './AppController'

const App = () => AppController

export default hot(module)(App)